import React, { useMemo } from "react";

export default function FAQPage() {
  const cancellations = useMemo(
    () => [
      {
        q: "I received a defective item from TYKA Sports. How do I get it replaced? OR I received an incorrect order. What can I do ?",
        a: (
          <div className="space-y-4 text-m leading-7 text-black-800">
            <ol className="list-decimal pl-6 space-y-2">
              <li>
                You notify us of any defects in the product or incorrectly
                shipped at the time of delivery or within 48 hours of receipt of
                the product. You can either email our Customer Service team at
                coordinator@tyka.com or call us on +91-181-5006935/
                +91-9803061407
              </li>
              <li>
                You book a shipping pickup with us, and ensure that the product
                is picked up from your premise by our courier within 15 days. To
                book a shipping pickup, schedule a courier pickup with our
                customer support team who will in turn arrange a suitable time
                with our courier partner. <strong>Note:</strong> if you have
                agreed a time for pick up, and the courier fails to find you at
                the address, there will be a Rs 100 charge payable by you at the
                time of delivery of the replacement. Each time that you are not
                there, there is a Rs 100 charge (that’s what it costs us to
                bring your stuff back).
              </li>
              <li>
                The product is returned to us with
                <ul className="list-disc pl-6 mt-2 space-y-1">
                  <li>customer invoice.</li>
                  <li>
                    all its original packaging and accessories, including the
                    box, manufacturer’s packaging if any, dustbags, warranty
                    cards, authenticity labels and all other items originally
                    included with the product(s) delivered.
                  </li>
                  <li>and is unused condition</li>
                </ul>
                <p className="mt-3">
                  As soon as we have received the product, we will ship you the
                  replacement, with no additional cost to you. You will receive
                  an email when a replacement has been shipped out.
                </p>
              </li>
              <li>
                In the event that a replacement is not available in stock, we
                will offer you a credit or a full cash refund.
              </li>
              <li>
                In the event that a replacement is available in stock, and you
                do not want a replacement, we will offer you a full refund
                either via the card you used to pay us, or in the case of a COD
                payment, by a cheque.
              </li>
              <li>
                If the product received back by us does not meet the 3
                specifications above, then the product can neither be replaced,
                nor can a refund be provided. If you still wish to get the same
                product back, we will be happy to do so, as long as you are ok
                to bear the shipping expenses.
              </li>
              <li>
                If the product is deemed not to have a manufacturing defect, but
                has been damaged because of misuse — we will not replace, only
                arrange for a credit which you can use with us within 6 months.
              </li>
              <li>
                You can seek a replacement for the entire purchase or part(s) of
                the purchase.
              </li>
              <li>
                Needless to say, we can offer to replace only product(s)
                purchased on TYKA Sports.
              </li>
            </ol>
          </div>
        ),
      },
      {
        q: "What is your Return/Cancellation Policy?",
        a: (
          <div className="space-y-4 text-m leading-7 text-black-800">
            <ol className="list-decimal pl-6 space-y-3">
              <li>
                You can return any product that you have received as long as
                <ul className="list-disc pl-6 mt-2 space-y-1">
                  <li>customer invoice</li>
                  <li>
                    all its original packaging and accessories, including the
                    box, manufacturer’s packaging if any, dustbags, warranty
                    cards, authenticity labels and all other items originally
                    included with the product(s) delivered.
                  </li>
                  <li>and is unused / original condition</li>
                </ul>
              </li>
              <li>
                You need to make sure that
                <ul className="list-disc pl-6 mt-2 space-y-1">
                  <li>
                    <strong>Damaged/Defective/Wrong Product:</strong> You must
                    notify us of any defects in the product or incorrectly
                    shipped at the time of delivery or within 48 hours of
                    receipt of the product.
                  </li>
                  <li>
                    <strong>Any Other Returns:</strong> You must inform us of
                    your intention to return the item to us (within 2 days,
                    including weekends) and of delivery of the product.
                  </li>
                </ul>
              </li>
            </ol>
          </div>
        ),
      },
      {
        q: "How quickly will I get the refund?",
        a: (
          <p className="text-m leading-7 text-black-800">
            Please note that we do not offer refunds, only exchanges.
          </p>
        ),
      },
      {
        q: "My product was damaged in transit. What should I do?",
        a: (
          <p className="text-m leading-7 text-black-800">
            At the point of delivery, if the package seems to have been tampered
            with i.e. TYKA Sports tape is broken/missing, please do not accept
            the order.
          </p>
        ),
      },
      {
        q: "I want to cancel an order (I have not yet received it).",
        a: (
          <div className="space-y-4 text-m leading-7 text-black-800">
            <ol className="list-decimal pl-6 space-y-3">
              <li>
                You can cancel an order in one of two ways:
                <ul className="list-disc pl-6 mt-2 space-y-1">
                  <li>
                    Call us on{" "}
                    <a href="tel:+919803061407" className="underline">
                      +91‑9803061407
                    </a>
                    .
                  </li>
                  <li>
                    or write to us on{" "}
                    <a href="mailto:coordinator@tyka.com" className="underline">
                      coordinator@tyka.com
                    </a>
                    . If you cancel an order by calling us, before the
                    product(s) has been shipped to you, we will refund you the
                    entire amount.
                  </li>
                </ul>
              </li>
              <li>
                If you cancel an order which has already been shipped to you,
                you can do one of the following:
                <ul className="list-disc pl-6 mt-2 space-y-1">
                  <li>
                    If your product has been shipped but has not yet been
                    delivered, contact Customer Support and inform them of the
                    same.
                  </li>
                  <li>
                    If despite informing us, since the package has already left
                    for your address, you receive the product, you can return
                    the product through the same courier (i.e. do not accept the
                    package).
                  </li>
                  <li>
                    If you have received the order, and are now wanting to
                    cancel (i.e. return the product), then please follow the
                    steps above. We can only process the credit once we have
                    received the product – and it meets the three criteria
                    above.
                  </li>
                </ul>
              </li>
            </ol>
            <div>
              <p>
                To maintain our high standard of hygiene and professional
                service, we shall accept returns of all items except the
                following :
              </p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>inner wear/base layer/compression.</li>
                <li>socks.</li>
                <li>free items / items purchased during sale.</li>
              </ul>
            </div>
          </div>
        ),
      },
      {
        q: "I want to return a product (that I have already received).",
        a: (
          <div className="space-y-4 text-m leading-7 text-black-800">
            <ol className="list-decimal pl-6 space-y-3">
              <li>
                You can return any product that you have received as long as
                <ul className="list-disc pl-6 mt-2 space-y-1">
                  <li>customer invoice.</li>
                  <li>
                    all its original packaging and accessories, including the
                    box, manufacturer’s packaging if any, dustbags, warranty
                    cards, authenticity labels and all other items originally
                    included with the product(s) delivered.
                  </li>
                  <li>and is unused / original condition.</li>
                </ul>
              </li>
              <li>
                You need to make sure that you inform us of your intention to
                return the item to us and ensure that the product(s) reaches us
                within 15 days of delivery of the product.
              </li>
            </ol>
          </div>
        ),
      },
      {
        q: "Our Exchange Policy",
        a: (
          <div className="space-y-4 text-m leading-7 text-black-800">
            <ol className="list-decimal pl-6 space-y-3">
              <li>
                <strong>Eligibility for Exchange:</strong>
                <ul className="list-disc pl-6 mt-2 space-y-1">
                  <li>
                    Exchanges can only be made if the size of the item does not
                    match the size guide provided on our website.
                  </li>
                  <li>
                    The item must be returned within 48 – 72 hours of delivery.
                  </li>
                  <li>
                    The product must be unused, in its original condition, and
                    in the original packaging.
                  </li>
                  <li>
                    Certain items, such as [Accessories Items – Bags, Hat, Caps,
                    supporters, Compressions, Shoes, Foam Roller ] are not
                    eligible for exchange.
                  </li>
                </ul>
              </li>
              <li>
                <strong>How to Request an Exchange:</strong>
                <ul className="list-disc pl-6 mt-2 space-y-1">
                  <li>
                    If you believe the size you received does not match the size
                    guide, kindly share clear images of the garments placed on a
                    flat surface with a measuring tape included.
                  </li>
                  <li>
                    For shirts, please place the measuring tape across the chest
                    area and from the shoulder to the waist.
                  </li>
                  <li>
                    For trousers, please place the measuring tape along the
                    length of the trouser and across the waist
                  </li>
                  <li>
                    These images will help us cross-check the measurements on
                    our end and assess whether there is an issue with the
                    sizing.
                  </li>
                </ul>
              </li>
              <li>
                <strong>Exchange Process:</strong>
                <ul className="list-disc pl-6 mt-2 space-y-1">
                  <li>
                    Once we review the images and confirm that the size is
                    incorrect based on our size guide, we will arrange a free
                    replacement for you.
                  </li>
                  <li>
                    If the size is correct according to the size guide, but you
                    still wish to exchange, we will proceed with the
                    replacement, and the buyer will be responsible for the
                    shipping charges.
                  </li>
                </ul>
              </li>
              <li>
                <strong>Shipping Fees:</strong>
                <ul className="list-disc pl-6 mt-2 space-y-1">
                  <li>
                    Return shipping fees are the responsibility of the customer
                    if the size is correct and the exchange is requested for
                    other reasons. However, if the size is incorrect as per the
                    size guide, we will cover the shipping cost for the
                    replacement.
                  </li>
                </ul>
              </li>
            </ol>
          </div>
        ),
      },
    ],
    []
  );

  const others = useMemo(
    () => [
      {
        q: "Are the products I purchase on TYKA Sports covered by a warranty / guarantee?",
        a: `At TYKA Sports, we work hard to give you best of products. If they offers a Warranty on a product, we pass on the same to you. For most product lines however, there are no manufacturer’s warranty other then manufacturing defects. Shopping at www.tyka.com is exactly the same as if you were buying products in a shopping mall or from local shops.`,
      },
      {
        q: "Does TYKA Sports deliver Internationally?",
        a: `TYKA Sports doesn’t deliver items internationally as of now but you can get them from our authorised dealers (see dealers locations) in your choice of country or you can reach us at sales@tyka.com for further information or orders. You are more than welcome to make your purchases on our site from anywhere in the world, but you’ll have to ensure the delivery address is within India.`,
      },
      {
        q: "Is there a difference between what I see and what I buy?",
        a: `With TYKA Sports, what you see is what you get. We work hard on photographing images as is. Our team gives you an elaborate description of the product with detailed specifications of each item. Our team makes sure to send out products that meet the TYKA Sports aesthetic and stringent quality standards. If despite this you don’t fall in love with what you get, give us a call within 48 hours to book a return.`,
      },
    ],
    []
  );

  return (
    <main className="min-h-screen bg-white">
      <section className="max-w-7xl mx-auto px-2 md:px-4 pt-8 md:pt-12">
        <h5 className="text-2xl md:text-3xl font-bold tracking-tight">
          Frequently Asked Questions (FAQs)
        </h5>
        <p className="mt-6 max-w-5xl text-sm md:text-base text-gray-600">
          The following informative page is designed to help you with some of
          the most common questions regarding your order on tyka.com
        </p>
      </section>

      <section className="max-w-7xl mx-auto px-2 md:px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 lg:gap-6">
          {/* Left column */}
          <div className="border border-gray-200">
            <div className="p-4 pb-0">
              <h2 className="text-xl md:text-2xl font-bold">
                Cancellation, Returns &amp; Exchange
              </h2>
              <p className="mt-2 text-sm text-gray-600">
                The section covers the most frequent concerns customers might
                have regarding cancellation, exchanging or returning a product.
              </p>
            </div>
            <div className="mt-3 border-t" />

            <div className="divide-y">
              {cancellations.map((item, i) => (
                <details key={i} className="group">
                  <summary className="list-none px-4 py-3 cursor-pointer select-none flex items-start gap-3 bg-neutral-50 hover:bg-neutral-100 border-b font-bold">
                    <span className="mt-1 text-lg font-extrabold leading-none group-open:hidden">
                      ›
                    </span>
                    <span className="mt-1 text-lg font-extrabold leading-none hidden group-open:inline">
                      ▾
                    </span>
                    <span className="text-sm md:text-base text-gray-800 font-bold">
                      {item.q}
                    </span>
                  </summary>
                  <div className="px-6 pb-5 pt-4 text-l text-black-800 bg-white">
                    {item.a}
                  </div>
                </details>
              ))}
            </div>
          </div>

          {/* Right column */}
          <div className="border border-gray-200">
            <div className="p-4 pb-0">
              <h2 className="text-xl md:text-2xl font-semibold">
                Other Questions
              </h2>
              <p className="mt-2 text-sm text-gray-600">
                If you haven’t found the answer to your query in one of the
                above FAQ sections, read on for more helpful information.
              </p>
            </div>
            <div className="mt-3 border-t" />

            <div className="divide-y">
              {others.map((item, i) => (
                <details key={i} className="group">
                  <summary className="list-none px-4 py-3 cursor-pointer select-none flex items-start gap-3 bg-neutral-50 hover:bg-neutral-100 border-b font-bold">
                    <span className="mt-1 text-lg font-extrabold leading-none group-open:hidden">
                      ›
                    </span>
                    <span className="mt-1 text-lg font-extrabold leading-none hidden group-open:inline">
                      ▾
                    </span>
                    <span className="text-sm md:text-base font-bold text-gray-900">
                      {item.q}
                    </span>
                  </summary>
                  <div className="px-6 pb-5 pt-4 text-m text-black-800 bg-white ">
                    {item.a}
                  </div>
                </details>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Help Section aligned left */}
      <section className="max-w-7xl mx-auto px-2 md:px-4 pb-12 text-left">
        <h3 className="text-lg md:text-xl font-semibold">Still Need help?</h3>
        <p className="mt-2 text-sm md:text-base text-gray-800">
          Contact us at Call: +91-9803061407 or Email: coordinator@tyka.com for
          all your queries.
        </p>
      </section>
    </main>
  );
}
